import React from "react";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useWishlist } from "@/context/WishlistContext";
import { toggleWishlist } from "@/lib/api";
import { toast } from "sonner";

export const WishlistButton = ({ slug, showCount = true, size = "md" }) => {
  const { user, setUser, openAuthModal } = useAuth();
  const { counts, bump } = useWishlist();
  const saved = !!(user && (user.wishlist || []).includes(slug));
  const count = counts[slug] || 0;

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      openAuthModal();
      return;
    }
    try {
      const res = await toggleWishlist(slug);
      const nowSaved = res.wishlist.includes(slug);
      setUser({ ...user, wishlist: res.wishlist });
      bump(slug, nowSaved ? 1 : -1);
      toast.success(nowSaved ? "Saved to your wishlist." : "Removed from wishlist.");
    } catch {
      toast.error("Could not update wishlist.");
    }
  };

  const iconSize = size === "lg" ? "w-5 h-5" : "w-4 h-4";

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`wishlist-toggle-${slug}`}
      aria-label={saved ? "Remove from wishlist" : "Save to wishlist"}
      className={`flex items-center gap-1.5 backdrop-blur-sm border transition-colors ${
        size === "lg" ? "px-4 py-2.5" : "px-2.5 py-1.5"
      } ${
        saved
          ? "bg-[#5B2A86]/90 border-[#5B2A86] text-foreground"
          : "bg-black/50 border-border text-foreground hover:border-foreground"
      }`}
    >
      <Heart className={iconSize} strokeWidth={1.6} fill={saved ? "currentColor" : "none"} />
      {showCount && count > 0 && (
        <span
          data-testid={`wishlist-count-${slug}`}
          className="font-mono text-[10px] tracking-widest"
        >
          {count}
        </span>
      )}
    </button>
  );
};

export default WishlistButton;
